/**
 * 优惠券管理说明
 * @param {string} text - 名称
 * @param {string} value - 字段
 */
export const tableColumn = [{
    text: '优惠券名称',
    value: 'name',
  }, {
    text: '基础面额',
    value: 'couponPriceBdStr',
  }, {
    text: '使用门槛',
    value: 'useTypeStr',
  }, {
    text: '是否可膨胀',
    value: 'isCanExpandStr',
  }, {
    text: '最高可膨胀至金额',
    value: 'maxExpandPriceStr',
  }, {
    text: '有效期',
    value: 'expireDate',
  }, {
    text: '领取人数',
    value: 'getCount',
  },{
    text: '新用户领取人数',
    value: 'newFansCount',
  }, {
    text: '已膨胀',
    value: 'expandCount',
  },{
    text: '已使用',
    value: 'useCount',
  },{
    text: '已过期',
    value: 'expireCount',
  },{
    text: '投入金额',
    value: 'couponCommissionAmountStr',
  },{
    text: '佣金收益',
    value: 'appCommissionAmountStr',
  },{
    text: '启用状态',
    value: 'activityStatusStr',
  },{
    text: '创建时间',
    value: 'createTime',
  }]

/**
 * 优惠券使用情况说明
 * @param {string} text - 名称
 * @param {string} value - 字段
 */
export const tableColumnUse = [{
    text: '用券用户',
    value: 'userTag',
  }, {
    text: '领券时间',
    value: 'createTimeStr',
  }, {
    text: '优惠券名称',
    value: 'couponName',
  }, {
    text: '优惠券基础面值',
    value: 'couponPriceBd',
  }, {
    text: '膨胀金额',
    value: 'expandPriceBd',
  }, {
    text: '优惠券状态',
    value: 'statusStr',
  }, {
    text: '用券订单',
    value: 'orderId',
  }, {
    text: '市场价',
    value: 'initPriceBd',
  },{
  text: '虚拟加价',
  value: 'virtualAddPrice',
  },{
    text: '券后支付价',
    value: 'couponPayPriceBd',
  },{
    text: '原特惠价',
    value: 'preferentialPriceBd',
  },{
    text: '用券时间',
    value: 'useTimeStr',
  }]



// WEBPACK FOOTER //
// ./src/views/pc/miniProgram/couponNew/enum.js